// extracted by mini-css-extract-plugin
export default {"DropDownMenu":"DropDownMenu_DropDownMenu__en0dy","box":"DropDownMenu_box__2+Der"};